/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultipleChoiceQuestionV2 } from './MultipleChoiceQuestionV2';
import {
    MultipleChoiceQuestionV2FromJSON,
    MultipleChoiceQuestionV2FromJSONTyped,
    MultipleChoiceQuestionV2ToJSON,
    MultipleChoiceQuestionV2ToJSONTyped,
} from './MultipleChoiceQuestionV2';
import type { TimeOfDayQuestionV2 } from './TimeOfDayQuestionV2';
import {
    TimeOfDayQuestionV2FromJSON,
    TimeOfDayQuestionV2FromJSONTyped,
    TimeOfDayQuestionV2ToJSON,
    TimeOfDayQuestionV2ToJSONTyped,
} from './TimeOfDayQuestionV2';
import type { QuestionGroupV2 } from './QuestionGroupV2';
import {
    QuestionGroupV2FromJSON,
    QuestionGroupV2FromJSONTyped,
    QuestionGroupV2ToJSON,
    QuestionGroupV2ToJSONTyped,
} from './QuestionGroupV2';
import type { IntegerRangeQuestionV2 } from './IntegerRangeQuestionV2';
import {
    IntegerRangeQuestionV2FromJSON,
    IntegerRangeQuestionV2FromJSONTyped,
    IntegerRangeQuestionV2ToJSON,
    IntegerRangeQuestionV2ToJSONTyped,
} from './IntegerRangeQuestionV2';

/**
 * 
 * @export
 * @interface QuestionV2
 */
export interface QuestionV2 {
    /**
     * 
     * @type {string}
     * @memberof QuestionV2
     */
    _default?: string;
    /**
     * 
     * @type {QuestionGroupV2}
     * @memberof QuestionV2
     */
    group?: QuestionGroupV2;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionV2
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionV2
     */
    id?: string;
    /**
     * 
     * @type {MultipleChoiceQuestionV2}
     * @memberof QuestionV2
     */
    multipleChoice?: MultipleChoiceQuestionV2;
    /**
     * 
     * @type {IntegerRangeQuestionV2}
     * @memberof QuestionV2
     */
    numberRange?: IntegerRangeQuestionV2;
    /**
     * 
     * @type {string}
     * @memberof QuestionV2
     */
    text?: string;
    /**
     * 
     * @type {TimeOfDayQuestionV2}
     * @memberof QuestionV2
     */
    timeOfDay?: TimeOfDayQuestionV2;
}

/**
 * Check if a given object implements the QuestionV2 interface.
 */
export function instanceOfQuestionV2(value: object): value is QuestionV2 {
    return true;
}

export function QuestionV2FromJSON(json: any): QuestionV2 {
    return QuestionV2FromJSONTyped(json, false);
}

export function QuestionV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionV2 {
    if (json == null) {
        return json;
    }
    return {
        
        '_default': json['default'] == null ? undefined : json['default'],
        'group': json['group'] == null ? undefined : QuestionGroupV2FromJSON(json['group']),
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
        'id': json['id'] == null ? undefined : json['id'],
        'multipleChoice': json['multiple_choice'] == null ? undefined : MultipleChoiceQuestionV2FromJSON(json['multiple_choice']),
        'numberRange': json['number_range'] == null ? undefined : IntegerRangeQuestionV2FromJSON(json['number_range']),
        'text': json['text'] == null ? undefined : json['text'],
        'timeOfDay': json['time_of_day'] == null ? undefined : TimeOfDayQuestionV2FromJSON(json['time_of_day']),
    };
}

export function QuestionV2ToJSON(json: any): QuestionV2 {
    return QuestionV2ToJSONTyped(json, false);
}

export function QuestionV2ToJSONTyped(value?: QuestionV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'default': value['_default'],
        'group': QuestionGroupV2ToJSON(value['group']),
        'hidden': value['hidden'],
        'id': value['id'],
        'multiple_choice': MultipleChoiceQuestionV2ToJSON(value['multipleChoice']),
        'number_range': IntegerRangeQuestionV2ToJSON(value['numberRange']),
        'text': value['text'],
        'time_of_day': TimeOfDayQuestionV2ToJSON(value['timeOfDay']),
    };
}

